<div class="bdo-loading__wrapper" [class.bdo-loading__wrapper--height]="state === LoadingState.LOADING">
  @if (state === LoadingState.LOADING) {
    <bdo-loading></bdo-loading>
  }
  @if (state === LoadingState.ERROR) {
    <bdo-info-box>
      {{ 'general.error.error' | translate }}
    </bdo-info-box>
  }
  @if (state === LoadingState.IDLE) {
    <div>
      <div class="re-summary-row">
        <div>{{ 'general.customerData.account' | translate }}</div>
        <div>{{accountId}}</div>
      </div>
      <div class="re-summary-row re-mb-0">
        <div>{{ 'general.tariff.deliveryAddress' | translate }}</div>
        <div [innerHtml]="address | address"></div>
      </div>
    </div>
  }
</div>
